import { render, staticRenderFns } from "./HighlightedOtherServices.vue?vue&type=template&id=340f5024&scoped=true&"
import script from "./HighlightedOtherServices.vue?vue&type=script&lang=js&"
export * from "./HighlightedOtherServices.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedOtherServices.vue?vue&type=style&index=0&id=340f5024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f5024",
  null
  
)

export default component.exports